module.exports = __webpack_public_path__ + "img/2695.22531a17.png";